<template>
    <div class="modal_wrapper">
        <div class="modal_container">
            <div class="modal_title">
                <span class="title">{{ modalTitle }}</span>
                <button class="modal_button_close" @click="closeModal">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="21.000000" height="21.000000" viewBox="0 0 10 10" fill="none">
                        <path id="close_1_" d="M1.07321 0.174072L0.174713 1.06958C-0.0582275 1.30176 -0.0582275 1.69995 0.174713 1.96509L3.23627 5.0166L0.174713 8.06787C-0.0582275 8.30005 -0.0582275 8.69824 0.174713 8.96362L1.03995 9.82593C1.27289 10.0581 1.67221 10.0581 1.93845 9.82593L5 6.77441L8.06155 9.82593C8.29449 10.0581 8.69385 10.0581 8.96005 9.82593L9.82529 8.96362C10.0582 8.73145 10.0582 8.33325 9.82529 8.06787L6.76373 4.9834L9.82529 1.93213C10.0582 1.69995 10.0582 1.30176 9.82529 1.03638L8.96005 0.174072C8.72711 -0.0581055 8.32779 -0.0581055 8.06155 0.174072L5 3.22559L1.93845 0.174072C1.70551 -0.0581055 1.30615 -0.0581055 1.07321 0.174072Z" fill="#174A8B" fill-opacity="1.000000" fill-rule="nonzero" />
                    </svg>
                </button>
            </div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'newModal',
        props: {
            modalTitle: {
                type: String,
                default: 'modalTitle'
            }
        },
        methods: {
            closeModal: function() {
                if (document.querySelector('.modal_wrapper') && document.querySelector('.modal_container')) {
                    document.querySelector('.modal_container').classList.remove('show');
                    document.querySelector('.modal_container').classList.remove('show');
                }

                setTimeout(() => {
                    this.$emit('close');
                }, 300);
            },
            onKeyPressed: function(event) {
                if (event.key === 'Escape') {
                    this.closeModal();
                }
            }
        },
        mounted() {
            setTimeout(() => {
                document.querySelector('.modal_wrapper').classList.add('show');
                document.querySelector('.modal_container').classList.add('show');

                document.addEventListener('click', (event) => {
                    if (!event.target.closest(".modal_container")) {
                        this.closeModal();
                    }
                });
            }, 30);
            window.addEventListener('keydown', this.onKeyPressed);
        },
        beforeDestroy() {
            window.removeEventListener('keydown', this.onKeyPressed);
            document.removeEventListener('click', this.closeModal);
        }
    };
</script>

<style scoped>
    .modal_wrapper {
        background-color: rgba(0, 0, 0, .3);

        position: fixed;
        top: 0;
        left: 0;
        z-index: 9998;

        width: 100%;
        height: 100%;

        /* Для анимации */
        opacity: 0;
        transition: all .3s ease-in-out;
    }

    .modal_wrapper.show {
        opacity: 1;
    }

    .modal_container {
        font-family: 'DIN Pro', Helvetica, Arial, sans-serif;
        background-color: #fff;

        display: flex;
        flex-direction: column;

        width: 99%;
        max-width: 789px;
        gap: 30px;
        height: fit-content;

        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        padding: 30px 30px 34px 25px;

        /* Для анимации */
        margin-top: -30px;
        opacity: 0;
        transition: all .3s ease-in-out;
    }

    .modal_container.show {
        margin-top: 0;
        opacity: 1;
    }

    .modal_title {
        display: flex;
        justify-content: space-between;
    }

    .modal_title .title {
        font-weight: bold;
        font-size: 30px;
        line-height: 38px;
        color: rgb(23, 74, 139);
    }

    .modal_button_close {
        background: none;
        border: none;
        cursor: pointer;

        transition: all .2s ease-out;
    }

    .modal_button_close:hover {
        transform: scale(1.15);
    }

    @media (max-width: 768px) {
        .modal_container {
            width: 90%;
            height: auto;
            padding: 20px 20px 15px;
        }

        .modal_title .title {
            font-size: 24px;
            text-align: center;
        }
    }
</style>
